import { render, staticRenderFns } from "./index.vue?vue&type=template&id=cd6cf14c&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=cd6cf14c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd6cf14c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/sihong_test_front_mall/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cd6cf14c')) {
      api.createRecord('cd6cf14c', component.options)
    } else {
      api.reload('cd6cf14c', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=cd6cf14c&scoped=true", function () {
      api.rerender('cd6cf14c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ImgDrag/index.vue"
export default component.exports